import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Blockquote } from "../../Blockquote/index.js";
import { ModuleLayout } from "../Layout/ModuleLayout.js";
import { moduleTestimonialsVariants } from "./ModuleTestimonials.variants.js";
const ModuleTestimonials_ModuleTestimonials = /*#__PURE__*/ forwardRef(function({ testimonials = [], maxColumns, children, ...sectionProps }, ref) {
    let autoColumns = 3;
    if (1 === testimonials.length) autoColumns = 1;
    else if (2 === testimonials.length) autoColumns = 2;
    const computedColumns = 'simpleSplit' === sectionProps.display ? 1 : autoColumns;
    const columns = maxColumns ? Math.min(maxColumns, computedColumns) : computedColumns;
    const { gridWrapper, grid } = moduleTestimonialsVariants({
        columns,
        display: sectionProps.display
    });
    const defaultContent = /*#__PURE__*/ jsx("div", {
        className: gridWrapper(),
        children: /*#__PURE__*/ jsx("div", {
            className: grid(),
            children: testimonials.map((props, i)=>/*#__PURE__*/ jsx(Blockquote, {
                    ...props
                }, props.attribution ?? String(i)))
        })
    });
    return /*#__PURE__*/ jsx(ModuleLayout, {
        ref: ref,
        ...sectionProps,
        children: children ?? defaultContent
    });
});
export { ModuleTestimonials_ModuleTestimonials as ModuleTestimonials };
